import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

function Hero() {
    return (
        <section
            id="hero"
            className="bg-brand-bege min-h-screen flex flex-col items-center justify-center text-center p-4"
        >
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                <h1 className="text-4xl md:text-6xl font-extrabold text-brand-grafite font-montserrat mb-4">
                    Soluções em Estratégia & Gente
                </h1>
                <p className="text-lg md:text-xl text-brand-grafite/80 max-w-2xl mx-auto mb-8">
                    Construindo culturas organizacionais saudáveis e formando times de alta performance.
                </p>
                <Link
                    to="contact"
                    smooth={true}
                    duration={500}
                    className="cursor-pointer inline-block bg-brand-rosa text-white px-8 py-3 rounded-lg font-bold hover:bg-opacity-90 shadow-lg transform hover:-translate-y-1 transition-all duration-300"
                >
                    Vamos conversar
                </Link>
            </motion.div>
        </section>
    );
}

export default Hero;
